import { RaisedHands } from '@bnnvara/icons/src/components/AnimatedIcons/RaisedHands/RaisedHands';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const LikeButton = ({
  likes,
  isLikedByUser,
  onClick,
  disabled
}) => {
  const showLikes = !!likes;
  return /*#__PURE__*/React.createElement(S.LikeButton, {
    onClick: onClick,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(RaisedHands, {
    isActive: isLikedByUser,
    size: "lg"
  }), showLikes && /*#__PURE__*/React.createElement(S.AmountLikes, null, " ", likes, " "));
};

LikeButton.propTypes = {
  isLikedByUser: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  likes: PropTypes.number,
  disabled: PropTypes.bool
};
LikeButton.defaultProps = {
  likes: null,
  disabled: false
};
export default LikeButton;